import { render, staticRenderFns } from "./OrganizationsListChip.vue?vue&type=template&id=f5ed867c&scoped=true"
import script from "./OrganizationsListChip.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationsListChip.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationsListChip.vue?vue&type=style&index=0&id=f5ed867c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ed867c",
  null
  
)

export default component.exports